/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type PublicTestSourceConnectionResponseV2Dto = {
    errorMessages?: Array<string>;
    status?: PublicTestSourceConnectionResponseV2Dto.status;
    successMessages?: Array<string>;
    warningMessages?: Array<string>;
};

export namespace PublicTestSourceConnectionResponseV2Dto {

    export enum status {
        SUCCESS = 'SUCCESS',
        WARNING = 'WARNING',
        ERROR = 'ERROR',
    }


}
